
import { Box,Flex,Grid,Image,Text,Container } from "@chakra-ui/react";



import Carousel from "./Crousel";
import Footer from "../Component/Footer";
// import Footerr from "../pages/Crousel"

function Home() {
  return (
   <div>
  
   

   
    <div>
   
   <Box   >
  <Image src="./images/s1.jpg" alt='s1' >
  
  </Image>
  
  </Box>
  <Carousel/>
<Flex gap="30px" m="40px">
<Image boxSize='650px' src="./images/s1 (1).jpg" 
alt="" />

<Image boxSize='650px' src="./images/s1 (2).jpg" 
alt="" />

</Flex >
<Flex  m="0px 60px">
<h2>Essentials by Buynow</h2>

</Flex>
{/* ---------------------grid stable 2 */}
<h1 >Artist Collab</h1>
<Grid gridTemplateColumns="repeat(4,1fr)" textAlign="center">

<Container>
<Image boxSize='350px' src="./images/s2 (1).jpg" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (1).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (2).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (3).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (4).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (5).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (6).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (7).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (8).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (9).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (10).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (11).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (12).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (13).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (14).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (15).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container><Container>
<Image boxSize='350px' src="./images/s2 (16).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (17).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (18).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (19).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (20).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (21).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (22).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
<Container>
<Image boxSize='350px' src="./images/s2 (23).png" 
alt="" />
  <h3>Essentials</h3>
  <h2>Ned Joggers</h2>
  <h5>Rs.1490</h5>
</Container>
</Grid>



{/* ---------------------------------stable------------------------------


*/}
<Carousel/>
<Text fontSize="30px" pt="30px" textAlign="center" pb="10px">Brands on Buynow </Text>

<Grid gridTemplateColumns="repeat(8,1fr)" m="10px">
<Image src="./images/s3 (1).jpg" 
alt="" />
<Image src="./images/s3 (2).jpg" 
alt="" />
<Image src="./images/s3 (3).jpg" 
alt="" />
<Image src="./images/s3 (4).jpg" 
alt="" />
<Image src="./images/s3 (5).jpg" 
alt="" />
<Image src="./images/s3 (6).jpg" 
alt="" />
<Image src="./images/s3 (7).jpg" 
alt="" />
<Image src="./images/s3 (8).jpg" 
alt="" />
<Image src="./images/s3 (9).jpg" 
alt="" />
<Image src="./images/s3 (10).jpg" 
alt="" />
<Image src="./images/s3 (11).jpg" 
alt="" />

</Grid>






   </div>
   <Footer />
   </div>
  )
}
export default Home;